module.exports = __webpack_public_path__ + "static/media/read.66403829.svg";